<template>
  <v-card
    min-height="190px"
    elevation="3"
    class="d-flex align-start flex-column mb-1 pb-3 pl-3"
    outlined
    tile
  >
    <div class="mb-auto" outlined tile>
      <v-card-text>
        <div class="text-h5 mb-1">
          {{ symposia.acronym }} -
          {{ symposia.name }}
        </div>
        <v-list-item-subtitle>
          {{ $t("inscriptions") }}: {{ symposia.total }}
        </v-list-item-subtitle>
      </v-card-text>
    </div>

    <div class="pa-0" outlined tile>
      <v-card-actions>
        <v-btn
          rounded
          class="white--text"
          :color="symposia.color"
          @click="openSymposia()"
        >
          Open
        </v-btn>
      </v-card-actions>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    symposia: {
      type: Object
    }
  },
  methods: {
    openSymposia() {
      this.$router.push({
        name: "SymposiaDetail",
        params: { symposiaId: this.symposia.id, symposia: this.symposia }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>